import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { post } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function CreateHiringSourceModal({ isOpen, toggle, refreshSettings, hiringSourceToEdit }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [sourceData, setSourceData] = useState({
    name: hiringSourceToEdit?.name || null,
  });

  useEffect(() => {
    if(hiringSourceToEdit) {
      setSourceData({
        name: hiringSourceToEdit?.name || null,
      });
    } else {
      setSourceData({
        name: null,
      });
    }
  }, [hiringSourceToEdit, isOpen]);

  const saveHiringSource = async () => {
    setSaveLoading(true);
    const url = hiringSourceToEdit ? `/hr/hiring-sources/update/${hiringSourceToEdit.id}` : '/hr/hiring-sources/store';
    const data = await post(url, sourceData)
    if(data?.success) {
      refreshSettings();
      toggle();
      toast.success(hiringSourceToEdit ? t('alerts.success_update') : t('alerts.success_create'));
    } else {
      toast.error(data?.message || t('alerts.error'));
      toggle();
    }
    setSaveLoading(false);
  }

  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>
        {hiringSourceToEdit ? t('hr.settings.hiringSources.edit') : t('hr.settings.hiringSources.create_new')}
      </ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input 
            value={sourceData?.name}
            onChange={e => setSourceData({...sourceData, name: e.target.value})}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <DefaultButton color="secondary" size="sm" outline onClick={toggle}>{t('common.cancel')}</DefaultButton>
        <DefaultButton 
          color="primary" 
          size="sm" 
          onClick={saveHiringSource}
          loading={saveLoading}
          disabled={saveLoading || !sourceData?.name}
        >{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default CreateHiringSourceModal;